import React from 'react';
import { string } from 'prop-types';

import styles from './AppointmentDurationEstimation.scss';

export const AppointmentDurationEstimation = ({ className = '', estimationTime }) => (
  <p
    data-testid="AppointmentDurationEstimation"
    className={`${styles.AppointmentDurationEstimation} ${className}`}
  >
    Based on the information you&#39;ve provided, you&#39;ll need{' '}
    <span data-testid="AppointmentDurationEstimationTime">{estimationTime}</span> for your
    appointment.
  </p>
);

export const MemoizedAppointmentDurationEstimation = React.memo(AppointmentDurationEstimation);

AppointmentDurationEstimation.propTypes = {
  className: string,
  estimationTime: string.isRequired,
};
